import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Shortcut } from "components/WarehouseElements/WarehouseHeaders/WarehouseSearchZone/Shortcuts/Shortcuts";

interface GridLayout {
  gridWidth: number;
  gridHeight: number;
  zoom: number;
  shortcuts: Shortcut[];
}

const initialState = {
  gridWidth: 0,
  gridHeight: 0,
  zoom: 100,
  shortcuts: [],
} satisfies GridLayout as GridLayout;

export const gridLayoutSlice = createSlice({
  name: "gridLayoutSlice",
  initialState,
  reducers: {
    setGridHeight(state, action: PayloadAction<number>) {
      state.gridHeight = action.payload;
    },

    setGridWidth(state, action: PayloadAction<number>) {
      state.gridWidth = action.payload;
    },

    setGridZoom(state, action: PayloadAction<number>) {
      state.zoom = action.payload;
    },
    setGridCheckpoints(state, action: PayloadAction<Shortcut[]>) {
      const filteredShortcuts = action.payload.filter(
        (item, index) => action.payload.indexOf(item) === index
      );
      state.shortcuts = filteredShortcuts;
    },
  },
});

export const { setGridHeight, setGridWidth, setGridZoom, setGridCheckpoints } =
  gridLayoutSlice.actions;
export default gridLayoutSlice.reducer;
